import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TwoColumnLayoutComponent } from '@kempower-nx-workspace/layout-templates';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'ce-shell-two-col-route-wrap',
    imports: [CommonModule, TwoColumnLayoutComponent, RouterModule],
    templateUrl: './twoColRouteWrap.component.html',
    styleUrl: './twoColRouteWrap.component.scss'
})
export class TwoColRouteWrapComponent {}
